import { render } from "./edit_order_form.vue?vue&type=template&id=5e51153a"
import script from "./edit_order_form.vue?vue&type=script&lang=js"
export * from "./edit_order_form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__